import { useQuery } from "@tanstack/react-query";
import namesByIdsService from "../services/namesByIdsService";

export const useNamesByIds = (eventData) => {
  return useQuery({
    queryKey: ["namesByIds", eventData?.id],
    queryFn: () => namesByIdsService.getEventLookups(eventData),
    enabled: !!eventData,
    staleTime: 30 * 60 * 1000, // 30 minutes (data considered "fresh")
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
